import { all, call } from 'redux-saga/effects'
import tenant from 'App/redux/tenant/sagas'
import breadcrumb from 'App/redux/breadcrumb/sagas'

export default function* rootSaga(sagas?: any[]) {
  const appSagas = [tenant, breadcrumb]
  if (sagas) {
    sagas.forEach((s: any) => appSagas.push(s))
  }
  yield all(appSagas.map((s: any) => call(s)))
}
